import { useEffect, useState } from 'react';
import _logo from '../assets/logo.svg';
import '../assets/styles/login.css';
import UI_page_design_2 from '../assets/UI_page_design_2.svg'
import AlertPopup,{triggerAlert} from '../components/AlertMessage';
import Login from '../components/users/Login';
import UpdatePassword from '../components/users/UpdatePassword';
import UpdateUserDetails from '../components/users/UpdateUserDetails';
import ForgotPassword from '../components/users/ForgotPassword';
import ValidateOTP from '../components/users/ValidateOtp';


let loginUrl='/login',forgotPasswordUrl='/forgot-password',resetPasswordUrl='/reset-password',updatePasswordUrl='/update-password',newUserUrl='/new-user';

export default function User() {
  const [currentPage, setCurrentPage] = useState(window.location.pathname);

  useEffect(()=>{
    if(currentPage !=window.location.pathname){
      window.location.reload();
    }
  })

  return (
    <main
      style={{ width: "100%", height: "100%" }}
      className='login-page-container main-content main-content-bg mt-0 ps'
    >
      <AlertPopup />
      <section className='login-section'>
        <div className='page-header'>
          <div className='row-container'>
            <div className='login-row'>
              <div className='login-form-card-container col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto'>
                <div className='form-card card card-plain'>
                  <div className='form-card-header card-header pb-0 text-start'>
                    <img
                      src={_logo}
                      alt='KamerAI'
                      style={{ width: "180px", marginBottom: "1.5rem" }}
                    />
                    <h3 className='font-weight-bolder text-info text-gradient'>
                      {currentPage == resetPasswordUrl
                        ? "Reset Password"
                        : currentPage == updatePasswordUrl
                        ? "Update Password"
                        : currentPage == forgotPasswordUrl
                        ? "Forgot Password"
                        : "Welcome back"}
                    </h3>
                    <p className='form-card-header mb-0'>
                      {currentPage == resetPasswordUrl ||
                      currentPage == updatePasswordUrl
                        ? "Both password's must be same"
                        : currentPage == newUserUrl
                        ? "Enter your fist name and last name"
                        : currentPage == forgotPasswordUrl
                        ? "Enter your Email ID"
                        : "Enter your username and password to login"}
                    </p>
                  </div>
                  <div className='card-body'>
                    {currentPage == "/login" ? (
                      <Login
                        triggerAlert={triggerAlert}
                        setCurrentPage={setCurrentPage}
                      />
                    ) : currentPage == "/update-password" ||
                      currentPage == "/reset-password" ? (
                      <UpdatePassword
                        triggerAlert={triggerAlert}
                        setCurrentPage={setCurrentPage}
                      />
                    ) : currentPage == "/forgot-password" ? (
                      <ForgotPassword
                        triggerAlert={triggerAlert}
                        setCurrentPage={setCurrentPage}
                      />
                    ) : currentPage == "/validate-otp" ? (
                      <ValidateOTP
                        triggerAlert={triggerAlert}
                        setCurrentPage={setCurrentPage}
                      />
                    ) : (
                      currentPage == "/new-user" && (
                        <UpdateUserDetails triggerAlert={triggerAlert} />
                      )
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='right-container'>
                  <img src={UI_page_design_2} className='right-side-image' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Toast ref={toast} position="top-center" /> */}
    </main>
  );
}
